import {
  createTableEmptyState,
  type TableEmptyStateStyles,
} from './createTableEmptyState';
import styles from './TableEmptyState.module.css';

/**
 * Bound instance of `createTableEmptyState` for libs/ui's own internal
 * pages/components (e.g. NotFound, TaskActivityTimeline) that don't belong
 * to a consuming app and so can't be given an app-supplied CSS module.
 * Not exported from the public `@gokrew/ui` barrel — consuming apps should
 * call `createTableEmptyState` with their own styles instead.
 */
const LibsTableEmptyState = createTableEmptyState(
  styles as TableEmptyStateStyles
);

export default LibsTableEmptyState;
